var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.819,
    height: 9.179,
    viewBox: "0 0 16.819 9.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-eye",
    transform: "translate(0.444 0.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close-eye-2",
    "data-name": "close-eye",
    d: "M2.308,11.077a.762.762,0,0,1,1.019.35A8.122,8.122,0,0,0,4.4,13.081a.771.771,0,0,1,.059.069,7.159,7.159,0,0,0,2.1,1.688q.031.012.062.028t.068.039a6.274,6.274,0,0,0,5.627,0q.033-.021.068-.039t.062-.028a7.161,7.161,0,0,0,2.1-1.686.768.768,0,0,1,.063-.074,8.123,8.123,0,0,0,1.067-1.651.762.762,0,1,1,1.369.669,9.719,9.719,0,0,1-.871,1.449l1.105,1.105A.762.762,0,0,1,16.2,15.729L15.175,14.7a8.69,8.69,0,0,1-1.445,1.15l.642,1.28a.762.762,0,0,1-1.362.683l-.637-1.271a7.782,7.782,0,0,1-2.11.511v1.561a.762.762,0,0,1-1.524,0V17.058a7.782,7.782,0,0,1-2.11-.511l-.637,1.271a.762.762,0,0,1-1.362-.683l.642-1.28A8.694,8.694,0,0,1,3.825,14.7L2.8,15.729a.762.762,0,0,1-1.078-1.077l1.106-1.106a9.717,9.717,0,0,1-.871-1.45.762.762,0,0,1,.35-1.019Z",
    transform: "translate(-1.5 -11)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 0.75,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close-eye.b93adb3d8a41231f610ddd76f6d819c1.svg";
export { ForwardRef as ReactComponent };